import { Archive, CopyCheck, UserPlus } from 'lucide-react';
import { canEdit } from '@nest-recruit/shared';
import type { router as AppRouter } from '../../router';
import { registerCommands, type Command } from '../../shell/command-registry';

/**
 * S14's palette entries (06-qol §1). "Candidates" itself comes from the module bar;
 * these are the two places a recruiter goes from anywhere — adding a walk-in and
 * clearing the duplicate queue. Both need edit rights on candidates (§L23: HR Lead
 * and Recruiter), so nobody is offered a door that would refuse them.
 */
export function registerCandidateCommands(router: typeof AppRouter): () => void {
  const commands: Command[] = [
    {
      id: 'candidates.add',
      label: 'Add candidate',
      section: 'action',
      context: 'Candidates · CAND-07',
      permission: 'candidate',
      canSee: (session) => canEdit(session, 'candidate'),
      icon: UserPlus,
      keywords: ['walk-in', 'walk in', 'paper cv', 'new candidate', 'manual'],
      run: () => void router.navigate({ to: '/candidates/new' }),
    },
    {
      id: 'candidates.duplicates',
      label: 'Possible duplicates',
      section: 'navigate',
      context: 'Candidates · CAND-06',
      permission: 'candidate',
      canSee: (session) => canEdit(session, 'candidate'),
      icon: CopyCheck,
      keywords: ['duplicate', 'merge', 'same person', 'dedupe'],
      run: () => void router.navigate({ to: '/candidates/duplicates' }),
    },
    {
      // ADR 0046; hidden while the CV Bank is switched off (module-map).
      id: 'cvBank.open',
      label: 'CV Bank',
      section: 'navigate',
      context: 'Candidates · CVs kept for later',
      permission: 'candidate',
      canSee: (session) => canEdit(session, 'candidate'),
      icon: Archive,
      keywords: ['cv bank', 'cv', 'resume', 'kept', 'keep', 'bank', 'upload cv'],
      run: () => void router.navigate({ to: '/cv-bank' }),
    },
  ];
  return registerCommands(commands);
}
